export default "__VITE_ASSET__acf8e136__"